(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ReconnectCareCredentialDialogController', ReconnectCareCredentialDialogController);

    ReconnectCareCredentialDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'ReconnectCareCredential'];

    function ReconnectCareCredentialDialogController ($timeout, $scope, $uibModalInstance, entity, ReconnectCareCredential) {
        var vm = this;

        vm.reconnectCareCredential = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.reconnectCareCredential.id !== null) {
                ReconnectCareCredential.update(vm.reconnectCareCredential, onSaveSuccess, onSaveError);
            } else {
                ReconnectCareCredential.save(vm.reconnectCareCredential, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:reconnectCareCredentialUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
